import { render } from "./StorageManagement.vue?vue&type=template&id=5f17abf1&scoped=true"
import script from "./StorageManagement.vue?vue&type=script&lang=js"
export * from "./StorageManagement.vue?vue&type=script&lang=js"

import "./StorageManagement.vue?vue&type=style&index=0&id=5f17abf1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f17abf1"]])

export default __exports__